export * from './contactLog'
export * from './regExp'
export * from './time'

// approximately after this amount of milliseconds the CCP initialisation fails ("initCCP" method)
export const CCP_INIT_TIMEOUT_MS = 60000

export const HIERARCHY_LEVELS = ['LevelOne', 'LevelTwo', 'LevelThree', 'LevelFour', 'LevelFive']

export enum AgentMetricsStatus {
    TOO_MANY_AGENT_METRICS = 'TooManyAgentMetrics',
}
